export default __webpack_public_path__ + "static/media/other23.75dbd3d6.webp";